"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const unit_renderer_1 = require("./unit-renderer");
const log_context_1 = require("../../../context/log-context");
const log_1 = require("../../../model/log");
exports.WordRenderer = (0, react_1.memo)(({ word, onSelect, isInCurrentSentence, isInCurrentWord, }) => {
    const childrenRefs = (0, react_1.useRef)([]);
    const { logEvent } = (0, log_context_1.useLog)();
    (0, react_1.useEffect)(() => {
        if (isInCurrentWord) {
            childrenRefs.current.forEach((ref) => {
                ref === null || ref === void 0 ? void 0 : ref.scrollIntoView();
            });
        }
    }, [isInCurrentWord]);
    const onUnitClick = (0, react_1.useCallback)(() => {
        logEvent(log_1.LogEventType.Click, log_1.LogEventClickName.PassageWordClick, word);
        if (onSelect) {
            onSelect(word.audioOffset);
        }
    }, [logEvent, onSelect, word]);
    return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: word.units.map((unit, index) => {
            return ((0, jsx_runtime_1.jsx)(unit_renderer_1.UnitRenderer, { unit: unit, isInCurrentSentence: isInCurrentSentence, isInCurrentWord: isInCurrentWord, onClick: onUnitClick, ref: (el) => {
                    childrenRefs.current[index] = el;
                } }, index));
        }) }));
});
exports.WordRenderer.displayName = "WordRenderer";
